import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import DynamicBreadcrumbs from "../../../elements/v2/DynamicBreadcrumbs/DynamicBreadcrumbs";
import { observer } from 'mobx-react-lite';
import performancePageStore from '../../../store/conversations/pages/PerformancePageStore';
import { BreadcrumbContainer } from "./PerformancePage.styled";
const QuickSightEmbedding = require("amazon-quicksight-embedding-sdk");

const PerformancePage = observer(() => {
  const { embedURL, fetchEmbedUrl, clear } = performancePageStore;
  
  const dashboard = useRef(null);

  const embedQSearchBar = async () => {
    const { createEmbeddingContext } = QuickSightEmbedding;

    const embeddingContext = await createEmbeddingContext();

    const frameOptions = {
      url: embedURL,
      container: "#experience-container",
      height: "800px",
      width: "100%",
    };

    const contentOptions = {
      toolbarOptions: {
        export: true,
      },
    };

    const embeddedDashboardExperience = await embeddingContext.embedDashboard(
      frameOptions,
      contentOptions
    );
    dashboard.current = embeddedDashboardExperience;
  };

  useEffect(() => {
    fetchEmbedUrl();
    return () => {
      clear(); 
    };
  }, [fetchEmbedUrl, clear]);

  useEffect(() => {
    if (embedURL) {
      embedQSearchBar(); 
    }
  }, [embedURL]);

  const location = useLocation();
  const breadcrumbItems = [{ label: "Performance", path: "/v2/performance" }];

  return (
    <>
      <BreadcrumbContainer data-testid="breadcrumb-container">
        <DynamicBreadcrumbs
          items={breadcrumbItems}
          currentPath={location.pathname}
          data-testid="breadcrumbs"
        />
      </BreadcrumbContainer>
      <div id="experience-container" data-testid="experience-container"></div>
    </>
  );
});

export default PerformancePage;